import { ASSET_PATHS } from '../../utils/assetPath';

import './PDFFileIcon.css';

interface PDFFileIconProps {
  /**
   * Additional CSS class name
   */
  className?: string;
  /**
   * Icon size in pixels
   */
  size?: number;
  /**
   * Accessible label for the icon
   */
  ariaLabel?: string;
}

function PDFFileIcon({ className = '', size = 32, ariaLabel = 'PDF file' }: PDFFileIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`pdf-file-icon ${className}`}
      height={size}
      src={ASSET_PATHS.PDF_FILE_ICON}
      width={size}
    />
  );
}

export default PDFFileIcon;
